import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";

import { AuthContext } from "../contexts/AuthContext";
import { MaintenanceProvider } from "../contexts/MaintenanceContext";
import Sidebar from "../components/common/Sidebar";
import AlarmListener from "../components/common/AlarmListener";
import TopNavbar from "../components/common/TopNavbar";

import MachinesTab from "../components/maintenance/tabs/MachinesTab";
import ToolsTab from "../components/maintenance/tabs/ToolsTab";
import HistoryTab from "../components/maintenance/tabs/HistoryTab";
import HistoryToolsTab from "../components/maintenance/tabs/HistoryToolsTab";

import "./MaintenanceDashboard.css";

// Tab yang boleh diakses teknisi
const TEKNISI_TABS = ["machines", "tools", "history", "historytools"];

const TeknisiDashboard = () => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState("machines");
  const [mobileOpen, setMobileOpen] = useState(false);

  // Teknisi hanya boleh mengakses tab pada TEKNISI_TABS
  useEffect(() => {
    setActiveTab(TEKNISI_TABS.includes(tab) ? tab : "machines");
  }, [tab]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    window.location.href = "/login";
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "tools":
        return <ToolsTab />;
      case "history":
        return <HistoryTab />;
      case "historytools":
        return <HistoryToolsTab />;
      case "machines":
      default:
        return <MachinesTab />;
    }
  };

  return (
    <MaintenanceProvider>
      <AlarmListener showTest role="teknisi" />
      <div className="maintenance-dashboard-container">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          userRole="teknisi"
          onLogout={handleLogout}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        <div className="main-content">
          <TopNavbar
            activeTab={activeTab}
            currentUser={currentUser}
            handleLogout={handleLogout}
            userRole="teknisi"
          />

          <Container fluid className="px-3 py-2">
            {renderTabContent()}
          </Container>
        </div>
      </div>
    </MaintenanceProvider>
  );
};

export default TeknisiDashboard;
